import { createSelector } from 'reselect';

const getPartnerId = state => state.partnerManagerReducer.getIn(['manager', 'partnerID']);

export default createSelector(
    [getPartnerId],
    partnerId => ({
        partnerId
    })
);